import type { CleaningControlAction } from '../types/CleaningControls.types';
import { BRangeCleaningCommandType } from 'app/cross-cutting-concerns/communication/interfaces/pra-api-graphql';

/** Milliseconds in a minute. */
export const MS_PER_MINUTE = 60_000;

// Which control triggers each command, used to show the right pending state.
export const COMMAND_TYPE_TO_CONTROL_ACTION: Partial<Record<BRangeCleaningCommandType, CleaningControlAction>> = {
  [BRangeCleaningCommandType.MissionPause]: 'pauseResume',
  [BRangeCleaningCommandType.MissionResume]: 'pauseResume',
  [BRangeCleaningCommandType.MissionDriveBackAndCancel]: 'sendHome',
  [BRangeCleaningCommandType.MissionStop]: 'cancelCleaning',
  [BRangeCleaningCommandType.MissionDriveBackAndSkip]: 'skipRoute',
};

// Pause/Resume have no confirmation modal, so their failure is shown in the card / live map footer.
export const PAUSE_RESUME_COMMAND_TYPES = [
  BRangeCleaningCommandType.MissionPause,
  BRangeCleaningCommandType.MissionResume,
];

// Skip route has a confirmation modal, but it closes on confirm, so its failure is shown in the live map footer.
export const SKIP_ROUTE_COMMAND_TYPES = [BRangeCleaningCommandType.MissionDriveBackAndSkip];

export const SEND_HOME_COMMAND_TYPES = [BRangeCleaningCommandType.MissionDriveBackAndCancel];

// The cancel modal also offers Send home, so either failure belongs in it.
export const CANCEL_CLEANING_COMMAND_TYPES = [
  BRangeCleaningCommandType.MissionStop,
  BRangeCleaningCommandType.MissionDriveBackAndCancel,
];

// The card's "min left" is re-evaluated this often between progress updates.
export const CURRENT_ROUTE_MINUTES_TICK_MS = 30_000;
